export default "__VITE_ASSET__DBd02gvv__"